import { apiClient } from "./apiClientService";

export const fetchCoupons = async (cart, userId) => {
  return await apiClient(
    "POST",
    "/api/coupons/fetch-vendor-coupons",
    { cart, userId: userId || undefined },
    { skipLoading: true },
  );
};

export const fetchVendorCoupons = async () => {
  return await apiClient("GET", "/api/coupons/mine", null, { skipLoading: true });
};

export const validateCouponCode = async (code, cart, userId) => {
  return await apiClient(
    "POST",
    "/api/coupons/validate",
    { code, cart, userId: userId || undefined },
    { skipLoading: true },
  );
};

export const addCoupon = async (couponData) => {
  return await apiClient("POST", "/api/coupons", couponData);
};

export const updateCoupon = async (id, couponData) => {
  return await apiClient("PATCH", `/api/coupons/${id}`, couponData);
};

export const deleteCoupon = async (id) => {
  return await apiClient("DELETE", `/api/coupons/${id}`);
};
